var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "thumbs-slider"
  }, [_c('v-container', [_c('div', {
    staticClass: "thumbs-slider-top"
  }, [_c('swiper', {
    ref: "swiperTop",
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOptionTop
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('v-card', {
      staticClass: "thumbs-slider__inner",
      attrs: {
        "flat": "",
        "rounded": "0"
      }
    }, [_c('div', {
      staticClass: "thumbs-slider__img",
      style: 'background-image:url(' + item.img + ')'
    })])], 1);
  }), 1)], 1)]), _c('div', {
    staticClass: "thumbs-slider-thumbs"
  }, [_c('swiper', {
    ref: "swiperThumbs",
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOptionThumbs
    }
  }, [_vm._l(_vm.items, function (item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('v-card', {
      staticClass: "thumbs-slider__inner",
      attrs: {
        "flat": "",
        "rounded": "0"
      }
    }, [_c('div', {
      staticClass: "thumbs-slider__img",
      style: 'background-image:url(' + item.img + ')'
    })])], 1);
  }), _c('div', {
    staticClass: "swiper-control",
    attrs: {
      "slot": "pagination"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
      }
    },
    slot: "pagination"
  }, [_c('swiper-button-secondary'), _c('swiper-button-secondary', {
    attrs: {
      "next": ""
    }
  })], 1)], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }